export default __webpack_public_path__ + "static/media/employment_details.ad928ba6.svg";